import React from 'react';
import './forms.css';

const MineOwn = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLScmmd2LIn6iUFEkzyx7WcZ2GsvFvBevk2kR2zI-uQQjdS9WOw/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default MineOwn;